import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";
import {makeObservable} from "mobx";
import {PREDICTION_WIDGET} from "../predictions-widget.consts";

export class PredictionTabViewModel extends ListItemViewModel {
  constructor(model: ListItemViewModel) {
    super(model);

    makeObservable(this);
  }

  get analyticsLabel(): String {
    let analyticsLabel: String = PREDICTION_WIDGET.TABS_LABEL.main;

    if(this.index === PREDICTION_WIDGET.TABS.props) {
      analyticsLabel = PREDICTION_WIDGET.TABS_LABEL.props
    }

    return analyticsLabel;
  }
}